import {Component, Input} from '@angular/core';
import {TopTenDataDTO} from '../../model/types';

@Component({
  selector: 'app-topten',
  templateUrl: './topten.component.html',
  styleUrls: ['./topten.component.scss']
})
export class ToptenComponent {

  @Input() data: TopTenDataDTO | null = {medicinali: [], confezioni: []};

}
